import { Maximize2, Minimize2, X } from "lucide-react";
import Image from "next/image";

/**
 * Who you are talking to, and the panel's own controls.
 *
 * The name is the one piece of chrome this panel keeps, because it is not
 * chrome: somebody telling us about a payment they are owed should know who
 * they are addressing.
 *
 * The line under it says "Terac support" rather than naming what is answering,
 * because what is answering changes. An escalation is picked up by a person
 * writing as Sophia, so a subtitle that called her software would be false
 * exactly when somebody most needs to trust the reply. "Support" is the thing
 * that stays true on both sides of a handoff -- and it is what makes no promise
 * about how fast, which matters because an escalated thread can wait on a human
 * for hours.
 */
export function ThreadHeader({
  expanded,
  onToggleExpand,
  onClose,
}: {
  expanded?: boolean;
  onToggleExpand?: () => void;
  onClose?: () => void;
}) {
  return (
    <header className="border-border flex h-16 shrink-0 items-center gap-3 border-b px-4">
      <Image
        src="/brand/icon-tile.svg"
        alt=""
        width={40}
        height={40}
        className="size-9 shrink-0 rounded-[10px]"
      />
      <div className="min-w-0 flex-1">
        <p className="text-foreground truncate text-sm font-semibold">Sophia</p>
        <p className="text-muted-foreground truncate text-xs">Terac support</p>
      </div>
      {onToggleExpand ? (
        <button
          type="button"
          onClick={onToggleExpand}
          aria-pressed={expanded}
          aria-label={expanded ? "Shrink the chat" : "Expand the chat"}
          className="text-muted-foreground hover:text-foreground hover:bg-muted flex size-7 shrink-0 items-center justify-center rounded-full transition-colors"
        >
          {expanded ? (
            <Minimize2 className="size-3.5" aria-hidden />
          ) : (
            <Maximize2 className="size-3.5" aria-hidden />
          )}
        </button>
      ) : null}
      {onClose ? (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close the chat"
          className="text-muted-foreground hover:text-foreground hover:bg-muted flex size-7 shrink-0 items-center justify-center rounded-full transition-colors"
        >
          <X className="size-5" aria-hidden />
        </button>
      ) : null}
    </header>
  );
}
